import type { CustomNode, CustomEdge, CustomNodeData } from '@src/components/custom-nodes/types';
import type { SerializedNode, SerializedHashTable } from '@src/scenario-editor/utils/serializer/types';
import type { NodesDefinition } from '@src/scenario-editor/render-utils/types';
import { hydrateNodeAttrs, hydrateEdgeAttrs } from '@src/scenario-editor/utils/serializer';
import { recalculateNodesXPos, recalculateNodesYPosForNodes } from '@src/scenario-editor/utils';
import { recalculateHandlePositions } from '@src/scenario-editor/render-utils';

const dumpNode = (node: SerializedNode, nodeDefinitions: NodesDefinition) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { prevNodes, nextNodes, ...rest } = node;
  let relatedNodeDefinitionKey = Object.keys(nodeDefinitions)?.find(key => key === (rest.data as CustomNodeData)?.nodeType || '');

  if (!relatedNodeDefinitionKey) {
    const nodeDefinitionPatterns = Object.keys(nodeDefinitions).filter(pattern => pattern.includes('*'));
    relatedNodeDefinitionKey = nodeDefinitionPatterns
      .find(pattern => ((rest.data as CustomNodeData).nodeType ?? '').includes(pattern.split('*')[0]));
  }
  const relatedNodeDefinition = nodeDefinitions[relatedNodeDefinitionKey ?? ''] ?? {};

  if (relatedNodeDefinition) {
    return {
      ...rest,
      data: {
        ...rest.data as CustomNodeData,
        ...relatedNodeDefinition,
      }
    }
  }

  return rest;
};

export const deserealizeToNodesAndEdges = (hashTable: SerializedHashTable, nodeDefinitions: NodesDefinition) => {
  const nodes: Partial<CustomNode>[] = [];
  const edges: Partial<CustomEdge>[] = [];

  Object.values(hashTable ?? {}).forEach(node => {
    nodes.push(dumpNode(node, nodeDefinitions));

    node.nextNodes.forEach(nextNodeId => {
      edges.push({
        id: `edge:${node.id}=>${nextNodeId}`,
        source: node.id,
        target: nextNodeId,
      });
    });
  });

  const nodesWithSealedEdges = nodes.filter(node => (node.data as CustomNodeData)?.nodeType === 'message:goto');

  const hydratedNodes = nodes.map(hydrateNodeAttrs);
  const hydratedEdges = edges.map((item) => hydrateEdgeAttrs(item, nodesWithSealedEdges.map(node => node.id).includes(item.source)));

  recalculateNodesYPosForNodes(hydratedNodes, hydratedEdges);
  recalculateNodesXPos(
    hydratedNodes,
    undefined,
    {
      // @ts-expect-error emulation of instance object
      instance: {
        getNodes: () => hydratedNodes,
        getEdges: () => hydratedEdges,
      }
    }
  );
  recalculateHandlePositions(hydratedNodes, hydratedEdges);

  return {
    nodes: hydratedNodes,
    edges: hydratedEdges,
  };
}
